(function () {
  const GIFT_VARIANT_ID = 51788879855988;
  const THRESHOLD_CENTS = 20000;
  let processing = false;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  async function getCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    return res.json();
  }

  function paidSubtotal(cart) {
    return cart.items
      .filter((i) => i.variant_id !== GIFT_VARIANT_ID)
      .reduce((sum, i) => sum + i.final_line_price, 0);
  }

  function giftLine(cart) {
    return cart.items.find((i) => i.variant_id === GIFT_VARIANT_ID);
  }

  async function changeGift(quantity) {
    await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(GIFT_VARIANT_ID), quantity }),
    });
  }

  async function addGift() {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 }),
    });
  }

  async function refreshCartUI() {
    try {
      const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const data = await res.json();
      const apply = (id, html) => {
        const target = document.getElementById(`shopify-section-${id}`);
        if (!target || !html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(`shopify-section-${id}`);
        if (fresh) target.innerHTML = fresh.innerHTML;
      };
      apply('cart-drawer', data['cart-drawer']);
      apply('cart-icon-bubble', data['cart-icon-bubble']);
    } catch (e) {
      /* non-blocking */
    }
  }

  async function reconcile() {
    if (processing) return;
    processing = true;
    try {
      const cart = await getCart();
      const paid = paidSubtotal(cart);
      const gift = giftLine(cart);
      let mutated = false;

      if (paid >= THRESHOLD_CENTS) {
        if (!gift) { await addGift(); mutated = true; }
        else if (gift.quantity > 1) { await changeGift(1); mutated = true; }
      } else if (gift) {
        await changeGift(0);
        mutated = true;
      }

      if (mutated) await refreshCartUI();
    } catch (e) {
      /* fail silently; retry on next cart-update */
    } finally {
      processing = false;
    }
  }

  ready(() => {
    reconcile();
    if (window.FoxTheme && window.FoxTheme.pubsub) {
      window.FoxTheme.pubsub.subscribe(
        window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        () => reconcile()
      );
    }
  });
})();
